import type { ApiError } from '@/types/api.types'

export type PlanLimitType = 'projects' | 'storage' | 'users'

export function isPlanLimitError(err: unknown): err is ApiError & { planLimitExceeded: true } {
  if (!err || typeof err !== 'object') return false
  const candidate = err as ApiError
  return candidate.status === 402 && candidate.planLimitExceeded === true
}

export function notifyUnlessPlanLimit(
  err: unknown,
  notify: (message: string) => void,
  fallbackMessage: string,
): void {
  if (isPlanLimitError(err)) return
  notify(fallbackMessage)
}

export function normalizePlanLimitType(limit: unknown): PlanLimitType {
  if (limit === 'storage' || limit === 'users') return limit
  return 'projects'
}

export function usagePercent(used: number, max: number): number {
  if (!max || max <= 0) return 0
  return Math.min(100, Math.round((used / max) * 100))
}

export function formatStorageGb(gb: number): string {
  if (gb > 0 && gb < 0.01) return '< 0.01'
  if (gb >= 10) return gb.toFixed(0)
  return gb.toFixed(2)
}
